import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-modal-change-plan',
  templateUrl: './modal-change-plan.component.html',
  styleUrls: ['./modal-change-plan.component.scss']
})
export class ModalChangePlanComponent implements OnInit {

  @Input() isVisibleModal: boolean;
  @Input() isSubscribe: boolean;
  @Input() type: 'up-success' | 'down-success' | 'down-wrong' | 'success';
  @Output() closed: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor() { }

  ngOnInit(): void {
  }

  onClose(): void {
    this.closed.emit(true);
  }
}
